import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import ReactGA from 'react-ga4'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const GTAG = process.env.REACT_APP_GTAG

ReactGA.initialize(GTAG)

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

serviceWorkerRegistration.register()
